import { useQuery } from '@tanstack/react-query';
import Api from '../api/Api';
import { Dfs2SpectralResponse, IWaveSpectraParams } from '../types/waveSpectra';
import { QUERY_KEYS } from './queryKeys';

export function useGetWaveSpectraQuery(params: IWaveSpectraParams | null) {
  return useQuery<Dfs2SpectralResponse>({
    queryKey: [QUERY_KEYS.waveSpectra.spectrum, params],
    queryFn: () => {
      if (!params) {
        return Promise.reject(new Error('Wave spectra params are required'));
      }
      return Api.waveSpectra.getWaveSpectra(params);
    },
    enabled: !!params,
  });
}
